<template>
  <div class="top-ten-banks p-3">
    <h4>Top 10 banks in FinCEN Files by number of reports</h4>
    <p class="mb-0">Total number of reports filed by banks in the FinCEN Files.</p>
    <stacked-bar-chart :data="data" label-above hide-legend :social-mode="socialMode" :fixed-height="height" />
    <p class="text-muted mt-2 small text-right">Source: FinCEN Files data</p>
    <p class="mt-2 font-italic">This data is not representative of all SARs received by the U.S. Department of Treasury's Financial Crimes Enforcement Network. The 1,943 SARs in this data cover transactions between 1999 and 2017.</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  name: 'TopTenBanksByNumberFiled',
  mixins: [chart],
  data () {
    return {
      data: [
        { label: 'Deutsche Bank', value: 982 },
        { label: 'Bank of New York Mellon', value: 325 },
        { label: 'Standard Chartered', value: 232 },
        { label: 'JPMorgan', value: 107 },
        { label: 'Barclays', value: 104 },
        { label: 'HSBC', value: 73 },
        { label: 'Bank of America', value: 35 },
        { label: 'China Investment Corporation', value: 35 },
        { label: 'Wells Fargo', value: 21 },
        { label: 'Citigroup', value: 18 },
        { label: 'Société Générale', value: 11 }
      ]
    }
  }
}
</script>
